<template>
  <AppSkeletonCardTable v-if="loading"></AppSkeletonCardTable>
  <Card v-else>
    <template v-slot:title>Últimos Cadastrados</template>
    <template v-slot:content>
      <BovineDataTable
        :results="bovines"
        :columns="columns"
      />
    </template>
  </Card>
</template>

<script>
import { BovineApi } from '../../../services/api';
import BovineDataTable from '../../../components/BovineDataTable.vue';

export default {
  name: 'BovineLastInsertedCard',
  components: {
    BovineDataTable,
  },
  data() {
    return {
      bovines: [],
      loading: false,
      columns: [
        {
          field: 'earring',
          sortable: false,
          headerStyle: 'width: 80px',
        },
        {
          field: 'type',
          sortable: false,
          headerStyle: '',
        },
        {
          field: 'breed',
          sortable: false,
          headerStyle: '',
        },
        {
          field: 'weight',
          sortable: false,
          hide: true,
        },
        {
          field: 'status',
          hide: true,
        },
        {
          field: 'farmLot',
          hide: true,
        },
        {
          field: 'birthDate',
          hide: true,
        },
        {
          field: 'farm',
          sortable: false,
          headerStyle: '',
        },
        {
          field: 'bovineRoot',
          hide: true,
        },
        {
          field: 'owner',
          hide: true,
        },
      ],
    };
  },
  async created() {
    try {
      this.loading = true;
      const { results: bovines } = await BovineApi.fetch({
        order: 'desc',
        orderField: 'id',
        pageSize: 10,
        available: true,
      });
      this.bovines = bovines;
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style>
</style>